import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  ContainerDashboardCriticalModel,
  ContainerDashboardModel,
  KFSUserDashboardModel,
  TransactionDashboardModel,
  UserDashboardModel,
} from 'common/models/DashboardModel';
import { OperationStatus } from 'store/rootTypes';

const name = 'Dashboard';

interface IDashboardState {
  submitStatus: OperationStatus;
  ContainerDashboardList: ContainerDashboardModel[];
  ContainerDashboardCriticalList: ContainerDashboardCriticalModel[];
  UserDashboardList: UserDashboardModel[];
  KFSUserDashboardList: KFSUserDashboardModel[];
  TransactionNewDashboardList: TransactionDashboardModel[];
  TransactionPickupDashboardList: TransactionDashboardModel[];
  TransactionDropoffDashboardList: TransactionDashboardModel[];
}

const initialState: IDashboardState = {
  submitStatus: OperationStatus.idle,
  ContainerDashboardList: [],
  ContainerDashboardCriticalList: [],
  UserDashboardList: [],
  KFSUserDashboardList: [],
  TransactionNewDashboardList: [],
  TransactionPickupDashboardList: [],
  TransactionDropoffDashboardList: [],
};

export const DashboardSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    submitStatus: (state) => handlePendingSubmitAction(state),
    submitStatusRejected: (state, action: PayloadAction<string>) => handleSubmitRejection(state, action),
    submitStatusSucceeded: (state) => {
      state.submitStatus = OperationStatus.succeeded;
    },
    submitStatusSucceededNoPayload: (state) => {
      state.submitStatus = OperationStatus.succeeded;
    },
    resetSubmitStatus: (state) => {
      state.submitStatus = OperationStatus.idle;
    },
    SetContainerDashboardList: (state, action: PayloadAction<ContainerDashboardModel[]>) => {
      state.ContainerDashboardList = action.payload;
    },
    SetContainerDashboardCriticalList: (state, action: PayloadAction<ContainerDashboardCriticalModel[]>) => {
      state.ContainerDashboardCriticalList = action.payload;
    },
    SetUserDashboardList: (state, action: PayloadAction<UserDashboardModel[]>) => {
      state.UserDashboardList = action.payload;
    },
    SetKFSUserDashboardList: (state, action: PayloadAction<KFSUserDashboardModel[]>) => {
      state.KFSUserDashboardList = action.payload;
    },

    SetTransactionNewDashboardList: (state, action: PayloadAction<TransactionDashboardModel[]>) => {
      state.TransactionNewDashboardList = action.payload;
    },
    SetTransactionPickupDashboardList: (state, action: PayloadAction<TransactionDashboardModel[]>) => {
      state.TransactionPickupDashboardList = action.payload;
    },
    SetTransactionDropoffDashboardList: (state, action: PayloadAction<TransactionDashboardModel[]>) => {
      state.TransactionDropoffDashboardList = action.payload;
    },
  },
});

const handlePendingSubmitAction = (state) => {
  state.submitStatus = OperationStatus.pending;
};

const handleSubmitRejection = (state, action: PayloadAction<string>) => {
  state.submitStatus = OperationStatus.failed;
  console.error(action.payload);
};

export const { actions: DashboardActions } = DashboardSlice;

export default DashboardSlice.reducer;
